import * as actionTypes from "./actionTypes";
import { Actions, AuthProviders } from "./types";
import { Alert } from "records/Alert";

//--------------------------
// Basic Action Creators
//--------------------------
export function initApp(): Actions {
	return { type: actionTypes.INIT_APP };
}

export function appReady(): Actions {
	return { type: actionTypes.APP_READY };
}

export function notAuthenticated(): Actions {
	return { type: actionTypes.NOT_AUTHENTICATED };
}

export function authenticated(): Actions {
	return { type: actionTypes.AUTHENTICATED };
}

export function logoutAction(): Actions {
	return { type: actionTypes.LOGOUT };
}

export function createAlertAction(alert: Alert): Actions {
	return { type: actionTypes.CREATE_ALERT, alert };
}

export function deleteAlertAction(id: string): Actions {
	return { type: actionTypes.DELETE_ALERT, id };
}

export function updateUnreadAction(unreadCount: number): Actions {
	return { type: actionTypes.UPDATE_UNREAD, unreadCount };
}

export function setAuthType(
	authType: AuthProviders,
	tenant: string,
	clientId?: string
): Actions {
	return { type: actionTypes.SET_AUTH_TYPE, authType, clientId, tenant };
}

export function setRolesAction(roles: { [key: string]: string }): Actions {
	return { type: actionTypes.SET_ROLES, roles };
}

export function setManagedRolesAction(managedRoles: {
	[key: string]: string;
}): Actions {
	return { type: actionTypes.SET_MANAGED_ROLES, managedRoles };
}

export function setUsernameAction(username: string): Actions {
	return { type: actionTypes.SET_USERNAME, username };
}

export function setLegacyCheckboxes(
	legacyId: string,
	checkboxes: number[]
): Actions {
	return { type: actionTypes.SET_LEGACY_CHECKBOXES, legacyId, checkboxes };
}

export function setCheckedBoxes(checkboxes: string[]): Actions {
	return { type: actionTypes.SET_CHECKED_BOXES, checkboxes };
}

export function addCheckedBox(id: string): Actions {
	return { type: actionTypes.ADD_CHECKED_BOX, id };
}

export function removeCheckedBox(id: string): Actions {
	return { type: actionTypes.REMOVE_CHECKED_BOX, id };
}

export function setFormFullWidth(formFullWidth: boolean): Actions {
	return { type: actionTypes.FORM_FULL_WIDTH, formFullWidth };
}
